import React, { createContext, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { markFulfillmentPlanSetsAsPrinted } from '../../../../store/batches/batches.api';
import { getLabelQueBatchesRequest } from '../../../../store/label-que/label-que.actions';
import moment from 'moment';
import PropTypes from 'prop-types';

const MarkBatchAsPrintedContext = createContext({});

const MarkBatchAsPrintedContextProvider = ({ fulfillmentPlanSetId, batchPrintDate, children }) => {
  const dispatch = useDispatch();
  const [printDate, setPrintDate] = useAsyncSafeState(batchPrintDate);
  const [isProcessing, setIsProcessing] = useAsyncSafeState(false);
  const [hasError, setHasError] = useAsyncSafeState(false);
  const markAsPrinted = !printDate;
  const dateNow = moment().format();

  const onMarkAsPrintedChange = useCallback(() => {
    setIsProcessing(true);
    markFulfillmentPlanSetsAsPrinted([fulfillmentPlanSetId], markAsPrinted)
      .then((response) => {
        const { success } = response;
        setIsProcessing(false);
        if (success) {
          setPrintDate(markAsPrinted ? dateNow : undefined);
          dispatch(getLabelQueBatchesRequest());
          return;
        }
        setHasError(true);
      })
      .catch(() => {
        setIsProcessing(false);
        setHasError(true);
      });
  }, [fulfillmentPlanSetId, setIsProcessing, dispatch, setPrintDate, markAsPrinted, setHasError, dateNow]);

  const data = {
    printDate,
    isProcessing,
    hasError,
    onMarkAsPrintedChange,
  };
  return <MarkBatchAsPrintedContext.Provider value={data}>{children}</MarkBatchAsPrintedContext.Provider>;
};

MarkBatchAsPrintedContextProvider.propTypes = {
  batchPrintDate: PropTypes.string,
  fulfillmentPlanSetId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export { MarkBatchAsPrintedContext, MarkBatchAsPrintedContextProvider };
